import { ERsvpResponse } from '@/graphql-types/globalTypes';

export const READABLE_RSVP_RESPONSES = {
  [ERsvpResponse.GOING]: 'Going',
  [ERsvpResponse.MAYBE]: 'Maybe Going',
  [ERsvpResponse.NOT_GOING]: 'Not Going',
};
